<template>
  <div class="profile-tab-content">
    <section class="cart-section">
      <div class="row">
        <form class="px-0" v-on:submit.prevent="onSubmit">
          <div class="">
            <div class="row">
              <div class="checkout-page">
                <div class="checkout-form-1 theme-form">
                  <div class="row center-content">
                    <div class="col-lg-12 col-sm-12 col-xs-12">
                      <div class="theme-card check-out ng-star-inserted" style="box-shadow: none !important; border: none !important;">
                        <div style="display: flex;" class="flex-wrap">
                          <div class="form-group col-12 col-lg-6">
                            <div class="field-label">Father's Name</div>
                            <input type="text" id="father_name" disabled name="father_name" placeholder="Father's Name" class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.father_name">
                          </div>
                          <div class="form-group col-12 col-lg-6">
                            <div class="field-label">Mother's Name</div>
                            <input type="text" id="mother_name" disabled name="mother_name" placeholder="Mother's Name" class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.mother_name">
                          </div>
                        </div>
                        <div style="display: flex;" class="flex-wrap w-100% justify-content-sm-center justify-content-md-around align-items-center">
                          <div class="form-group col-sm-12 col-xs-12 col-lg-6">
                            <div class="field-label">Mobile no.</div>
                            <input type="text" v-if="profileEditable && !pQuota"  id="mobile" name="mobile" placeholder="Mobile no." class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.mobile" required>
                            <input type="text" v-else id="mobile" name="mobile" placeholder="Mobile no." class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.mobile" disabled required>
                          </div>
                          <div class="form-group col-sm-12 col-xs-12 col-lg-6">
                            <div class="field-label">Alternate Mobile no.</div>
                            <input type="text" v-if="profileEditable"  id="alternative_mobile" name="alternative_mobile" placeholder="Alternative Mobile no." class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.alternative_mobile" required>
                            <input type="text" v-else id="mobile" name="alternative_mobile" placeholder="Alternative Mobile no." class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.alternative_mobile" disabled required>
                          </div>
                        

                          <div class="form-group col-sm-12 col-xs-12 col-lg-6">
                            <div class="field-label">Gender</div>
                            <select v-if="profileEditable" name="gender"  class="modern-select" value="" v-model="registrationForm.gender" placeholder="Gender" autocomplete="off" required>
                              <option value="">Gender</option>
                              <option value="MALE" class="ng-star-inserted">Male</option>
                              <option value="FEMALE" class="ng-star-inserted">Female</option>
                            </select>
                            <select v-else disabled name="gender" class="modern-select" value="" v-model="registrationForm.gender" placeholder="Gender" autocomplete="off" required>
                              <option value="">Gender</option>
                              <option value="MALE" class="ng-star-inserted">Male</option>
                              <option value="FEMALE" class="ng-star-inserted">Female</option>
                            </select>
                          </div>

                          <div class="form-group col-sm-12 col-xs-12 col-lg-6">
                            <div class="field-label">Religion</div>
                            <select v-if="profileEditable" name="religion" class="modern-select" value="" v-model="registrationForm.religion" placeholder="Religion" autocomplete="off" required>
                              <option value="">Religion</option>
                              <option value="ISLAM" class="ng-star-inserted">Islam</option>
                              <option value="HINDUISM" class="ng-star-inserted">Hinduism</option>
                              <option value="BUDDHISM" class="ng-star-inserted">Buddhism</option>
                              <option value="CHRISTIANITY" class="ng-star-inserted">Christianity</option>
                              <option value="OTHER" class="ng-star-inserted">Other</option>
                            </select>
                            <select v-else disabled name="religion" class="modern-select" value="" v-model="registrationForm.religion" placeholder="Religion" autocomplete="off" required>
                              <option value="">Religion</option>
                              <option value="ISLAM" class="ng-star-inserted">Islam</option>
                              <option value="HINDUISM" class="ng-star-inserted">Hinduism</option>
                              <option value="BUDDHISM" class="ng-star-inserted">Buddhism</option>
                              <option value="CHRISTIANITY" class="ng-star-inserted">Christianity</option>
                              <option value="OTHER" class="ng-star-inserted">Other</option>
                            </select>
                            </select>
                          </div>

                          <div class="form-group col-sm-12 col-xs-12 col-lg-6">
                            <div class="field-label">Question Language</div>
                            <select v-if="profileEditable" name="medium" class="modern-select" value="" v-model="registrationForm.medium" placeholder="Question Paper Language" autocomplete="off" required>
                              <option value="">Your Choice</option>
                              <option value="Bangla" class="ng-star-inserted">Bangla</option>
                              <option value="English" class="ng-star-inserted">English</option>
                            </select>
                            <select v-else disabled name="medium" class="modern-select" value="" v-model="registrationForm.medium" placeholder="Question Language" autocomplete="off" required>
                              <option value="">Your Choice</option>
                              <option value="Bangla" class="ng-star-inserted">Bangla</option>
                              <option value="English" class="ng-star-inserted">English</option>
                            </select>
                          </div>

                          <div class="form-group col-sm-12 col-xs-12 col-lg-6">
                            <div class="field-label">Dominant Hand</div>
                            <select v-if="profileEditable" name="dominant_hand" class="modern-select" value="" v-model="registrationForm.dominant_hand" placeholder="Dominant Hand" autocomplete="off" required>
                              <option value="">Your Practice</option>
                              <option value="Right" class="ng-star-inserted">Right-Handed</option>
                              <option value="Left" class="ng-star-inserted">Left-Handed</option>
                            </select>
                            <select v-else disabled name="dominant_hand" class="modern-select" value="" v-model="registrationForm.dominant_hand" placeholder="Dominant Hand" autocomplete="off" required>
                              <option value="">Your Practice</option>
                              <option value="Right" class="ng-star-inserted">Right-Handed</option>
                              <option value="Left" class="ng-star-inserted">Left-Handed</option>
                            </select>
                          </div>

                          <div v-if="registrationForm.quotaObj!=null" class="form-group col-md-12 col-sm-12 col-xs-12" style="margin-bottom:25px; margin-top: 15px;">
                            <div style="margin-bottom:15px">
                              <h5 style="font-size: 16px; font-weight: 600; color: #2c3e50; margin: 0;">Quota (If Applicable)</h5>
                              <!-- <p style="font-size: 12px; color: #6c757d; margin: 3px 0 0 0;">Select all quotas that apply to you</p> -->
                              <div class="important-info">
                                <i class="fa fa-info-circle"></i>
                                <p>
                                  Select quotas that apply to you. After passing the admission test, applicant will have to submit proof of eligibility for the quotas he/she has filled online.
                                </p>
                              </div>
                            </div>
                            <div class="quota-grid" v-if="profileEditable">
                              <div class="quota-item" v-for="(quota,key) in registrationForm.quotaObj" :key="key">
                                <div class="modern-checkbox-wrapper">
                                  <input class="modern-checkbox" v-if="registrationForm.quotaObj[key].eligible" v-model="registrationForm.quotaObj[key].value" type="checkbox" :name="'pQuota'+key" :id="'pQuota'+key" :value=true :title="quota.title">
                                  <input class="modern-checkbox" v-else disabled v-model="registrationForm.quotaObj[key].value" type="checkbox" :name="'pQuota'+key" :id="'pQuota'+key" :value=true :title="quota.title">
                                  <label class="modern-checkbox-label" :for="'pQuota'+key" :title="quota.title">
                                    <span class="checkbox-icon"></span>
                                    <span class="checkbox-text">{{key + ' (' + registrationForm.quotaObj[key].title + ')'}}</span>
                                  </label>
                                </div>
                              </div>
                              <div class="col-12" v-if="onlyPCQPersonal && !registrationForm.quotaObj['PCQ'].value" style="margin-top: 10px;">
                                <div class="alert-box">
                                  <i class="fa fa-exclamation-circle"></i>
                                  <span>You must select PCQ to apply any Unit.</span>
                                </div>
                              </div>
                            </div>
                            <div class="quota-grid" v-else>
                              <div class="quota-item" v-for="(quota,key) in registrationForm.quotaObj" :key="key" :quota="quota">
                                <div class="modern-checkbox-wrapper">
                                  <input class="modern-checkbox" disabled v-model="registrationForm.quotaObj[key].value" type="checkbox" :name="'pQuota'+key" :id="'pQuota'+key" :value=true :title="quota.title">
                                  <label class="modern-checkbox-label" :for="'pQuota'+key" :title="quota.title">
                                    <span class="checkbox-icon"></span>
                                    <span class="checkbox-text">{{key + ' (' + registrationForm.quotaObj[key].title + ')'}}</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="field-label col-md-12 col-sm-12 col-xs-12" style="margin-top: 15px; margin-bottom: 15px;">
                            <h5 style="font-size: 16px; font-weight: 600; color: #2c3e50; margin: 0;">Exam Center Choice</h5>
                            <p style="font-size: 12px; color: #6c757d; margin: 3px 0 0 0;">Please select your preferred Exam Centers in order of priority. </p>
                            
                          </div>
                          <div style="display: flex;" class="col-md-12 col-sm-12 col-xs-12 flex-wrap justify-content-sm-center justify-content-md-around align-items-center">
                            <div class="form-group col-lg-4 w-100 col-md-12 col-sm-12 col-xs-12">
                              <label class="modern-label">First Choice</label>
                              <select v-if="profileEditable" name="centerChoice1" class="modern-select" value="" v-model="registrationForm.centerChoice1" placeholder="First Choice" autocomplete="off" required>
                                <option value="">Select First Choice</option>
                                <option value="cu" class="ng-star-inserted">Chittagong</option>
                                <option value="du" class="ng-star-inserted">Dhaka</option>
                                <option value="ru" class="ng-star-inserted">Rajshahi</option>
                              </select>
                              <select v-else disabled name="centerChoice1" class="modern-select" value="" v-model="registrationForm.centerChoice1" placeholder="First Choice" autocomplete="off" required>
                                <option value="">Select First Choice</option>
                                <option value="cu" class="ng-star-inserted">Chittagong</option>
                                <option value="du" class="ng-star-inserted">Dhaka</option>
                                <option value="ru" class="ng-star-inserted">Rajshahi</option>
                              </select>
                            </div>

                            <div class="form-group col-lg-4 w-100 col-md-12 col-sm-12 col-xs-12">
                              <label class="modern-label">Second Choice</label>
                              <select v-if="profileEditable" name="centerChoice2" class="modern-select" value="" v-model="registrationForm.centerChoice2" placeholder="Second Choice" autocomplete="off" required>
                                <option value="">Select Second Choice</option>
                                <option value="cu" class="ng-star-inserted">Chittagong</option>
                                <option value="du" class="ng-star-inserted">Dhaka</option>
                                <option value="ru" class="ng-star-inserted">Rajshahi</option>
                              </select>
                              <select v-else disabled name="centerChoice2" class="modern-select" value="" v-model="registrationForm.centerChoice2" placeholder="Second Choice" autocomplete="off" required>
                                <option value="">Select Second Choice</option>
                                <option value="cu" class="ng-star-inserted">Chittagong</option>
                                <option value="du" class="ng-star-inserted">Dhaka</option>
                                <option value="ru" class="ng-star-inserted">Rajshahi</option>
                              </select>
                            </div>

                            <div class="form-group col-lg-4 w-100 col-md-12 col-sm-12 col-xs-12">
                              <label class="modern-label">Third Choice</label>
                              <select v-if="profileEditable" name="centerChoice3" class="modern-select" value="" v-model="registrationForm.centerChoice3" placeholder="Third Choice" autocomplete="off" required>
                                <option value="">Select Third Choice</option>
                                <option value="cu" class="ng-star-inserted">Chittagong</option>
                                <option value="du" class="ng-star-inserted">Dhaka</option>
                                <option value="ru" class="ng-star-inserted">Rajshahi</option>
                              </select>
                              <select v-else disabled name="centerChoice3" class="modern-select" value="" v-model="registrationForm.centerChoice3" placeholder="Third Choice" autocomplete="off" required>
                                <option value="">Select Third Choice</option>
                                <option value="cu" class="ng-star-inserted">Chittagong</option>
                                <option value="du" class="ng-star-inserted">Dhaka</option>
                                <option value="ru" class="ng-star-inserted">Rajshahi</option>
                              </select>
                            </div>
                            </div>
                            <div class="important-info">
                              <i class="fa fa-info-circle"></i>
                              <p> If your first-choice center reaches full capacity, you will be allocated to your second or third preference. Center assignments will be made on a first-come, first-served basis, determined by the date and time of your application submission.

                              </p>
                            </div>
                          
                          <!-- <div class="d-flex flex-wrap flex-sm-col flex-md-row w-100 justify-content-sm-center justify-content-md-between align-items-baseline">
                            <div class="form-group col-md-5 col-xs-12" v-if="registrationForm.bill_number">
                              <div class="field-label">Bill Number</div>
                              <input type="text" disabled id="bill_number" name="bill_number" placeholder="Bill Number" class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.bill_number">
                            </div>
                            <div class="form-group col-md-7 col-xs-12" v-if="registrationForm.bill_number">
                              <div class="field-label">Amount</div>
                              <div class="col-12 align-items-center row">
                                <div class="col-lg-5 col-sm-6 col-xs-6 ">
                                  <input disabled type="text" id="amount" name="amount" placeholder="Amount" class="ng-untouched ng-pristine ng-invalid" v-model="registrationForm.amount">
                                </div>
                                <div class="col-lg-7 col-sm-5 col-xs-5 ">
                                  <div class="mb-2" style="font-weight: 600;font-size:22px" v-if="registrationForm.bill_status!=''">
                                    <b-badge style="font-size:16px;text-transform: uppercase;" v-if="registrationForm.bill_status=='confirmed'" variant="success">PAID</b-badge>
                                    <b-badge style="font-size:16px;text-transform: uppercase;" v-else-if="registrationForm.bill_status!='assigned' && registrationForm.bill_status != ''" variant="success">{{registrationForm.bill_status}}</b-badge>
                                    <b-badge style="font-size:16px" v-else variant="danger">DUE</b-badge>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!isPButtonLoading" class="container padding-cls text-center" style="width:100%;padding-top:45px;padding-bottom:25px;margin-bottom:10px">
              <button v-if="profileEditable && !isPButtonLoading" style="margin-top:10px;" class="btn info-btn btn-info radius-1" type="submit">
                <i class="fa fa-save"></i>
                Save Profile
              </button>
              <!-- <button v-if="openExam && (registrationForm.bill_status=='confirmed' && !closePaymentSlip)" class="btn info-btn btn-info radius-1" type="button" @click="onApplicationPaySlip" block>
                Payment Slip
              </button> -->
            </div>
            <div v-else  class="container padding-cls text-center" style="width:100%;padding-top:45px;padding-bottom:25px;margin-bottom:10px">
              <button  style="margin-top:10px" :class="isPButtonLoadingClass" type="button" block disabled>
                <i class="fa fa-spinner fa-spin"></i> Loading...
              </button>
            </div>
          </div>
        </form>
        <!-- <div class="text-danger" v-if="dew" style="font-weight:bold;font-size:18px;">
           Please pay 300/- using Rocket app to change your photograph, mobile number, question language, dominant hand, exam center choice and quota if applicable. Please Refresh your browser after successful payment.
        </div> -->
        <!-- <div style="width:100%;text-align:center" v-if="dew">
          <button style="margin-top:15px" @click="onReload" class="btn info-btn btn-info radius-1" type="button">
            Click here to reload this page
          </button>
        </div> -->
      </div>
    </section>
  </div>
</template>

<script>
import '@/assets/css/checkout-form-new.css'

export default {
  name: 'ProfilePersonal',
  props: {
    registrationForm: {
      type: Object,
      required: true,

    },
    profileEditable: {
      type: Number,
      default: 0
    },
    pQuota: {
      type: Boolean,
      default: true
    },
    onlyPCQPersonal: {
      type: Boolean,
      default: false
    },
    isPButtonLoading: {
      type: Boolean,
      default: false
    },
    isPButtonLoadingClass: {
      type: String,
      default: ''
    },
    openExam: {
      type: Boolean,
      default: false
    },
    closePaymentSlip: {
      type: Boolean,
      default: false
    },
    openCorrection: {
      type: Boolean,
      default: false
    },
    closeCorrection: {
      type: Boolean,
      default: false
    },
    photoEditable: {
      type: Number,
      default: 0
    },
    dew: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    // console.log(this.registrationForm.quotaObj);
  },
  methods: {
    // on load console.log registrationForm
    onSubmit() {
      this.$emit('submit');
    },
    onApplicationPaySlip() {
      this.$emit('payment-slip');
    },
    onReload() {
      window.location.reload();
    }
  }
}
</script>

<style scoped>
/* Modern Select Dropdown Styling */

.theme-card{
  box-shadow: none Imp !important;
}
.cart-section{
}

.profile-tab-content .padding-cls {
    /* padding-left: 15px; */
    padding: 0px;
}
.modern-select {
  width: 100% !important;
  max-width: 100% !important;
  padding: 10px 35px 10px 15px;
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236366f1' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 12px;
  border: 2px solid #e0e7ff;
  border-radius: 8px;
  transition: all 0.3s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

.modern-select:hover {
  border-color: #a5b4fc;
  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.1);
}

.modern-select:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.modern-select:disabled {
  background-color: #f8fafc;
  color: #94a3b8;
  cursor: not-allowed;
  opacity: 0.6;
}

.modern-select option {
  padding: 10px;
  font-size: 14px;
  color: #2c3e50;
}

/* Modern Label Styling */
.modern-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
  letter-spacing: 0.3px;
}

/* Quota Grid Layout */
.quota-grid {
  display: grid;
  gap: 5px;
  padding: 5px 0;
  width: 100%;
  align-items: center;
}

.quota-item {
  display: flex;
  align-items: center;
  background-color: #f3f4f5;
  border-radius: 8px  ;
  width: 100% ;
}

/* Modern Checkbox Styling */
.modern-checkbox-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.modern-checkbox {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.modern-checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  transition: all 0.2s ease;
  width: 100%;
  margin-bottom: 0px;
}

.modern-checkbox-label:hover {
  background-color: #f8faff;
}

.checkbox-icon {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e1;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  position: relative;
  background-color: #ffffff;
}

.checkbox-icon::after {
  content: '';
  position: absolute;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg) scale(0);
  transition: transform 0.2s ease;
  top: 2px;
  left: 6px;
}

.theme-form input[type="text"], .theme-form select{
  min-width: 100% !important;
}

.modern-checkbox:checked + .modern-checkbox-label .checkbox-icon {
  background-color: #6366f1;
  border-color: #6366f1;
}

.modern-checkbox:checked + .modern-checkbox-label .checkbox-icon::after {
  transform: rotate(45deg) scale(1);
}

.modern-checkbox:disabled + .modern-checkbox-label {
  opacity: 0.5;
  cursor: not-allowed;
}

.modern-checkbox:disabled + .modern-checkbox-label:hover {
  background-color: transparent;
}

.profile-tab-content .theme-form .modern-checkbox:disabled{
    opacity: 0;
}

.checkbox-text {
  font-size: 14px;
  font-weight: 500;
  color: #2c3e50;
  letter-spacing: 0.2px;
}

/* Alert Box Styling */
.alert-box {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border: 2px solid #fecaca;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #dc2626;
  font-size: 13px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.1);
}

.alert-box i {
  font-size: 18px;
  flex-shrink: 0;
}
.theme-form input[type="text"]{
  min-width: 100%;
}



.important-info {
  width: 95%;
  background: #f8f9fa;
  padding: 5px;
  border-left: 4px solid #6366f1;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 7px;
}

.important-info i {
  color: #6366f1;
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.important-info p {
  margin: 0;
  font-size: 13px;
  color: #575656;
  font-weight: 600;
}

.fee-amount {
  color: #dc3545;
  font-size: 17px;
  font-weight: 700;
}


/* Responsive Adjustments */
@media (max-width: 768px) {
  .quota-grid {
    gap: 10px;
  }

  .modern-select {
    padding: 9px 30px 9px 12px;
    font-size: 13px;
  }

  .modern-label {
    font-size: 12px;
  }

  .checkbox-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .quota-grid {
    gap: 8px;
  }

  .modern-checkbox-label {
    padding: 6px 10px;
  }

  .checkbox-icon {
    width: 18px;
    height: 18px;
  }

  .checkbox-text {
    font-size: 12px;
  }

  .alert-box {
    padding: 10px 12px;
    font-size: 12px;
  }
}
</style>
